import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])

export const pageSearch = {
  'saleCenter': {
    title: '营销中心',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'customerCode': {
    title: '经销商',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '经销商'
    }
  },
  'stockType': {
    title: '存货分类',
    type: 'select',
    equation: all,
    dictionary: 'A0019'
  }
}

export default {
  'saleCenterName': {
    title: '所属营销中心'
  },
  'customerName': {
    title: '经销商名称',
    width: 250
  },
  'customerCode': {
    title: '订单客户编码'
  },
  'stockTypeTextView': {
    title: '存货分类'
  },
  'planTypeTextView': {
    title: '计划类型',
    width: 200
  },
  //   'customerName': { 字段缺失
  //     title: '发票类型'
  //   },
  'leftQuantity': {
    title: '剩余量'
  },
  'freezeQuantity': {
    title: '冻结数量'
  },
  'unfreezeQuantity': {
    title: '解冻数量'
  },
  'createdDate': {
    title: '操作日期'
  },
  'frequency': {
    title: '计划年度'
  },
  //   'createdDate': { 字段缺失
  //     title: '备注'
  //   },
  'operation': {
    title: '操作',
    slot: true
  }

}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/data-searching/config/invoiceFreezeSearch.js